import { PreferenceSettingApi } from '@wiz-api/cloud-render-management'
import cloudRender from './index'

const preferenceApi = new PreferenceSettingApi()
let userPreferenceSettings = []
let defaultSettings = []
const PROJECT_NAME = Wiz.globalSettings.globalConfig?.modelSetting?.folderName || 'SAAS'

// 公共方法

// 生成guid
const generateGUID = () => {
  let d = new Date().getTime()
  if (window.performance && typeof window.performance.now === 'function') {
    d += performance.now()
  }
  const guid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (d + Math.random() * 16) % 16 | 0
    d = Math.floor(d / 16)
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
  })
  return guid
}

// 偏好设置 start

/**
 * @description: 获取默认设置
 * @return {*}
 */
const getDefaultSettings = async (player) => {
  const jsonData = await cloudRender.Setting.getSettingData(
    player,
    `data://../apps/${PROJECT_NAME}/settings.json`
  )
  if (jsonData && jsonData.status && jsonData.data) {
    defaultSettings = JSON.parse(jsonData.data)
  } else {
    defaultSettings.Show = (await cloudRender.Setting.getAll(player).data) || []
    const roamTrance = await cloudRender.Walking.getAllHotKey(player)
    defaultSettings.RoamTrance = _.reduce(
      roamTrance.data || [],
      (obj, item) => {
        obj[item.label] = item.code
        return obj
      },
      {}
    )
    defaultSettings.People = {
      avatarCapSkin: 'white',
      avatarBodySkin: 'red',
    }
  }
}

/**
 * @description: 获取用户偏好设置
 * @param {*} loadSetting 是否加载设置
 * @return {*}
 */
const getPreferenceSettings = async (loadSetting = false, player) => {
  const [err, res] = await preferenceApi.getCurrentUserSetting()
  if (!err && res) {
    const data = res.extraProperties
    userPreferenceSettings = data
    const modelDetail = (await JSON.parse(localStorage.getItem('modelDetail'))) || {}
    modelDetail.userPreferenceSettings = userPreferenceSettings
    localStorage.setItem('modelDetail', JSON.stringify(modelDetail))
    if (loadSetting) {
      setPreferenceSettings(player)
    }
  }
}

/**
 * @description: 设置用户偏好设置
 * @param {*} null
 * @return {*}
 */
const setPreferenceSettings = async (player) => {
  getPreferenceSettings(false, player)
  getDefaultSettings(player)
  if (userPreferenceSettings.Show) {
    const showData = await cloudRender.Setting.getAll(player)
    const showSettings = showData.data || []

    _.forIn(userPreferenceSettings.Show, (value, key) => {
      const settingInfo = _.find(showSettings, ['name', key])
      if (settingInfo) {
        let currentValue = ''
        if (settingInfo.type === 'bool') {
          currentValue = value === 'true' || value === true
        } else if (
          settingInfo.type === 'int' ||
          settingInfo.type === 'float' ||
          settingInfo.type === 'double'
        ) {
          currentValue = _.toNumber(value)
        } else {
          currentValue = value
        }
        cloudRender.Setting.set(player, {
          name: key,
          type: settingInfo.type,
          value: currentValue,
        })
      }
    })
  } else if (defaultSettings.Show) {
    _.forEach(defaultSettings.Show, (item) => {
      cloudRender.Setting.set(player, { name: item.name, type: item.type, value: item.value })
    })
  }
  const roamingSettings = userPreferenceSettings.RoamTrance
    ? userPreferenceSettings.RoamTrance
    : defaultSettings.RoamTrance
  _.forIn(roamingSettings, (value, key) => {
    let settingKeys = []
    if (userPreferenceSettings.RoamTrance) {
      const currentKeys = JSON.parse(value)
      settingKeys = currentKeys[0] || []
    } else {
      settingKeys = value[0] || []
    }
    cloudRender.Walking.setHotKeys(player, { name: key, code: settingKeys })
  })
  const RoamingSpeed = roamingSettings ? roamingSettings.RoamingSpeed : 1
  cloudRender.Walking.setAvatarSpeed(player, RoamingSpeed)
  const figureSettings = userPreferenceSettings.People
    ? userPreferenceSettings.People
    : defaultSettings.People
  const skinObj = {
    body: figureSettings.avatarBodySkin,
    head: figureSettings.avatarCapSkin,
  }
  cloudRender.Walking.setAvatarSkin(player, 'GongRen', skinObj)
}

// 偏好设置 end

// 下载相关 start

/**
 * 下载文件
 * @param {*} player player实例
 * @param {*} fileInfo 文件信息：{id:文件id,url:文件下载路径,fileType:文件类型}
 * @param {*} apiConfig 下载请求信息：{path:请求后端接口地址,method:请求方式,headers:接口请求头}
 * @returns 下载结果
 *          - type: 0为文件存在不需要下载，1为文件不存在需要下载
 *          - success: 下载成功或失败
 */
const downloadFile = async (
  player,
  fileInfo,
  apiConfig,
  progressMsg = () => {},
  downloadEndMsg = () => {}
) => {
  const isExists = await player.Native.File.exists(fileInfo.url)
  if (isExists) {
    return { type: 0, success: true }
  }
  // 模型中转文件
  const tempsUrl = `data://../temps/models/${fileInfo.id}/${fileInfo.id}.${fileInfo.fileType}`
  // 处理下载进度方法
  const processFun = (file, bytesReceived, bytesTotal) => {
    progressMsg(file, bytesReceived, bytesTotal)
  }
  // 处理下载结束方法
  const downloadEndFun = async (file, err) => {
    // const tempsMd5 = await player.Native.File.getFileMd5(tempsUrl)
    // if (tempsMd5 === fileInfo.md5) {
    //   // 移动文件到指定文件夹
    await player.Native.File.move(tempsUrl, fileInfo.url)
    if (fileInfo.fileType === 'zip') {
      await player.Native.UiQt.decompressingZIP(fileInfo.url, '')
    }
    // } else {
    //   app.$message.warning('当前请求的md5和服务器下载的md5不一致！')
    // }
    downloadEndMsg(file, err)
    player.Native.File.EventDownloadProcessChanged.disconnect(processFun)
    player.Native.File.EventDownloadFinish.disconnect(downloadEndFun)
  }
  // 监听下载进度
  player.Native.File.EventDownloadProcessChanged.connect(processFun)
  // 监听下载结束
  player.Native.File.EventDownloadFinish.connect(downloadEndFun)
  const res = await player.Native.File.downloadFile(
    tempsUrl,
    apiConfig.method,
    apiConfig.path,
    apiConfig.headers
  )
  return { type: 1, success: res }
}

// 下载相关 end

export { generateGUID, getPreferenceSettings, downloadFile }
